const slugify = (text) => {
  return text
    .toString()
    .normalize('NFD') // Normaliza los caracteres Unicode
    .replace(/[\u0300-\u036f]/g, '') // Elimina diacríticos
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') // Reemplaza espacios con guiones
    .replace(/[^\w-]+/g, '') // Elimina caracteres no permitidos
    .replace(/--+/g, '-'); // Elimina guiones múltiples
}
export default slugify; 